import { createFileRoute } from "@tanstack/react-router";
import { BrewSensorySessionDetailPage } from "@/features/brew-sensory/brew-sensory-session-detail-page";
import type { BrewSensorySessionId } from "@brewbase/db/types";

export const Route = createFileRoute(
  "/food-app/sensory/$brew_sensory_session_id",
)({
  component: RouteComponent,
  parseParams: (params) => ({
    brew_sensory_session_id: parseInt(params.brew_sensory_session_id, 10),
  }),
});

function RouteComponent() {
  const params = Route.useParams();
  return (
    <BrewSensorySessionDetailPage
      sessionId={params.brew_sensory_session_id as unknown as BrewSensorySessionId}
    />
  );
}
